"use strict";

module.exports = function () {
  return {
    framework: 'tailwind',
    table: 'table table-hover',
    row: 'row',
    column: '',
    label: 'label',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: '',
    left: '',
    center: 'text-center',
    contentCenter: 'justify-content-center',
    nomargin: 'm-0',
    groupTr: 'table-info',
    small: '',
    heading: 'heading',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: 'dropdown-item',
      caret: 'caret'
    },
    pagination: {
      nav: '',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item btn px-1 font-heading font-bold',
      link: 'page-link',
      next: 'text-dark-secondary',
      prev: 'text-dark-secondary',
      active: 'active',
      disabled: 'disabled'
    }
  };
};
